<div class="target-shell">
  <header class="target-header">
    <div>
      <h1>Target Areas</h1>
    </div>
    <div class="target-header__actions">
      <button type="button" class="button button--secondary" [routerLink]="['/audiences', serviceId()]">
        Back to Audiences
      </button>
    </div>
  </header>

  <nav class="breadcrumb">
    <a routerLink="/">Home</a>
    <span class="breadcrumb__separator">›</span>
    <a [routerLink]="['/audiences', serviceId()]" *ngIf="serviceId() as sid; else targetAudienceFallback">
      Target Audience Profiles
    </a>
    <ng-template #targetAudienceFallback>
      <span>Target Audience Profiles</span>
    </ng-template>
    <span class="breadcrumb__separator">›</span>
    <span>Target Areas</span>
  </nav>

  <section class="target-status">
    <span class="status status--info" *ngIf="loading()">
      <span class="spinner__dot"></span>
      <span>Loading target areas...</span>
    </span>
    <span class="status status--success" *ngIf="!loading() && statusMessage()">
      {{ statusMessage() }}
    </span>
    <span class="status status--error" *ngIf="errorMessage()">
      {{ errorMessage() }}
    </span>
  </section>

  <section class="target-table-wrapper" *ngIf="locations().length && !loading(); else emptyState">
    <table class="target-table">
      <thead>
        <tr>
          <th>Sub Location</th>
          <th>Target Audience</th>
          <th>Region</th>
          <th>Market Type</th>
          <th>Industry</th>
          <th>Company Size</th>
          <th class="target-table__actions-heading">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let location of locations()">
          <td>
            <span class="target-table__sublocation">
              {{ location.sub_location || 'N/A' }}
            </span>
          </td>
          <td>
            <div class="target-table__audience">
              <span>
                {{ location.target_audience || 'Target Audience' }}
              </span>
            </div>
          </td>
          <td>{{ location.location || 'N/A' }}</td>
          <td>{{ location.audience_type || location.market_type || 'N/A' }}</td>
          <td>{{ location.industry || 'N/A' }}</td>
          <td>{{ location.company_size || 'N/A' }}</td>
          <td class="target-table__actions">
            <button
              type="button"
              class="button button--primary button--small"
              (click)="viewAudience(location)"
            >
              View Details
            </button>
            <button
              type="button"
              class="button button--accent button--small"
              (click)="generateCompanies(location)"
              [disabled]="companyPending() === location.id"
            >
              <ng-container *ngIf="companyPending() !== location.id; else companyGenerationPending">
                Generate Target Companies
              </ng-container>
            </button>
            <button
              type="button"
              class="button button--accent button--small"
              (click)="viewCompanies(location)"
            >
              View Companies
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </section>

  <section class="target-company-section" *ngIf="activeLocationId() as selectedLocation">
    <header class="target-company-section__header">
      <h2>Target Companies for Location {{ selectedLocation }}</h2>
    </header>
    <div class="target-status">
      <span class="status status--info" *ngIf="companyPending() === selectedLocation">
        <span class="spinner__dot"></span>
        <span>Generating company profiles...</span>
      </span>
      <span class="status status--success" *ngIf="companyStatus() && companyPending() !== selectedLocation">
        {{ companyStatus() }}
      </span>
      <span class="status status--error" *ngIf="companyError()">
        {{ companyError() }}
      </span>
    </div>

    <ng-container *ngIf="companiesForLocation(selectedLocation) as companies">
      <table class="target-company-table" *ngIf="companies.length; else noCompanyResults">
        <thead>
          <tr>
            <th>Company</th>
            <th>Industry</th>
            <th>Location</th>
            <th>Size</th>
            <th>Website</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let company of companies">
            <td>{{ company.name || 'N/A' }}</td>
            <td>{{ company.industry || 'N/A' }}</td>
            <td>{{ company.location || 'N/A' }}</td>
            <td>{{ company.size || 'N/A' }}</td>
            <td>
              <a
                *ngIf="company.website; else noWebsite"
                [href]="company.website"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ company.website }}
              </a>
              <ng-template #noWebsite>N/A</ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </section>

  <ng-template #emptyState>
    <p class="target-empty">
      No target areas are available yet. Generate target areas from the previous page to populate this list.
    </p>
  </ng-template>

  <ng-template #companyGenerationPending>
    <span class="spinner">
      <span class="spinner__dot"></span>
      <span>Generating...</span>
    </span>
  </ng-template>

  <ng-template #noCompanyResults>
    <p class="target-empty target-empty--inline">
      No company records are available for this location yet.
    </p>
  </ng-template>
</div>
